import { configureStore } from '@reduxjs/toolkit';
import { combinedSlices } from 'slices';

export const store = configureStore({
  reducer: combinedSlices,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
